import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { useLocation } from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import SessionsListPage from './SessionsListPage';
import SessionManager from './SessionManager';
import { jsx as _jsx } from "react/jsx-runtime";
function EventSessionsManager(_ref) {
  var isNested = _ref.isNested,
    isBlockedByPlaylistChanges = _ref.isBlockedByPlaylistChanges,
    overallContentAudienceType = _ref.overallContentAudienceType,
    eventId = _ref.eventId,
    _ref$stickyHeaderComp = _ref.stickyHeaderCompensation,
    stickyHeaderCompensation = _ref$stickyHeaderComp === void 0 ? 0 : _ref$stickyHeaderComp;
  var location = useLocation();
  var _queryparse = queryparse(location.search),
    sessionId = _queryparse.sessionId;
  if (sessionId) {
    return /*#__PURE__*/_jsx(SessionManager, {
      isBlockedByPlaylistChanges: isBlockedByPlaylistChanges,
      isNested: isNested,
      overallContentAudienceType: overallContentAudienceType,
      sessionId: sessionId,
      eventId: eventId,
      stickyHeaderCompensation: stickyHeaderCompensation
    });
  }
  return /*#__PURE__*/_jsx(SessionsListPage, {
    eventId: eventId,
    isBlockedByPlaylistChanges: isBlockedByPlaylistChanges
  });
}
export default EventSessionsManager;
export * from './utils';